import { render, staticRenderFns } from "./GavHolidaysEdit.vue?vue&type=template&id=339fffb6&scoped=true"
import script from "./GavHolidaysEdit.vue?vue&type=script&lang=js"
export * from "./GavHolidaysEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339fffb6",
  null
  
)

export default component.exports